// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-4fd54376]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.step-control__next[data-v-4fd54376],.step-control__prev[data-v-4fd54376]{cursor:pointer}.step-control__next.disabled[data-v-4fd54376],.step-control__prev.disabled[data-v-4fd54376]{color:hsla(0,0%,100%,.6)!important;cursor:not-allowed}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
